import { Module } from "vuex";
import { RootState } from "../types";
import { JobCandidateInt } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: [],
} as JobCandidateInt;

export const jobCandidates: Module<JobCandidateInt, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
